export default function (address) {
    let data = [];

    if (address.companyname !== null) {
        data.push(address.companyname);
    }

    data.push((address.firstname ?? '') + ' ' + (address.lastname ?? ''));
    data.push((address.street ?? '') + ' ' + (address.housenr ?? '') + ' ' + (address.housenrext ?? ''));
    data.push((address.zipcode ?? '') + ' ' + (address.city ?? ''));
    data.push((address.country ?? ''));

    return data.join('<br />');
}
